if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');

        this.cartDrawerWrapper = document.querySelector("cart-drawer");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const formData = new FormData(this.form);
        const variantId = formData.get("id");

        // Check if a size is selected by checking if variant ID is empty or if no Size radio is checked
        const sizeFieldset = document.querySelector(
          "product-info variant-radios #Size, variant-radios #Size",
        );
        const sizeInputs =
          sizeFieldset ?
            sizeFieldset.querySelectorAll('input[type="radio"][name="Size"]')
          : [];
        const sizeSelected =
          sizeInputs.length > 0 ?
            Array.from(sizeInputs).some((input) => input.checked)
          : false;

        // If no variant ID or no size selected, show error and prevent submission
        if (
          !variantId ||
          variantId === "" ||
          (sizeInputs.length > 0 && !sizeSelected)
        ) {
          this.handleErrorMessage("Please select a size");
          this.submitButton.classList.remove("loading");
          this.querySelector(".loading__spinner")?.classList.add("hidden");
          return;
        }

        this.handleErrorMessage();
        const sendOnField = document.querySelector(
          'input[name="properties[Send on]"]',
        );
        if (sendOnField) {
          const selectedDate = new Date(sendOnField.value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          if (selectedDate < today) {
            sendOnField.setAttribute("aria-invalid", "true");
            return;
          }
        }
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        window.BAO.Cart.addItemFromForm(this.form)
          .then((state) => {
            if (!state) return;

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: state,
              });
            }
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              quickAddModal.hide(true);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            if (
              this.cartDrawerWrapper?.classList.contains("is-empty") &&
              this.cartDrawerWrapper?.classList.contains("ob-cart-empty")
            ) {
              removeCartDrawerClasses(this.cartDrawerWrapper, [
                "is-empty",
                "ob-cart-empty",
              ]);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        const addErrorBorder = document.querySelector(
          "product-info variant-radios #Size",
        );
        const addSizeInput = document.querySelector(
          "product-info variant-radios #Size input",
        );
        const addBtn = document.querySelector(
          "product-form .product-form__buttons .product-form__submit span",
        );
        if (addSizeInput) {
          addSizeInput.addEventListener("click", removeErrorBorder);
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        const giftDddBtn = document.querySelector(
          "product-form form input[name='gift-card']",
        );

        if (giftDddBtn && giftDddBtn.value == "yes") {
          const variantDropdown = document.querySelector(
            "variant-selects .select select",
          );
          if (variantDropdown) {
            variantDropdown.addEventListener("click", removeErrorBorder);
          }
          if (variantDropdown && variantDropdown.value == "") {
            variantDropdown.style.border = "2px solid #EB333D";
            errorMessage = "This field is required";
            this.errorMessage.textContent = errorMessage;
          }
        }

        if (this.hideErrors) return;

        if (!this.errorMessageWrapper) return;

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          if (addErrorBorder)
            addErrorBorder.style.borderBottom = "2px solid #EB333D";
          if (addBtn) {
            addBtn.textContent = "Please select a size";
            document
              .querySelector(
                "product-form .product-form__buttons .product-form__submit",
              )
              .setAttribute("disabled", true);
          }
        }
      }
    },
  );
}
function removeErrorBorder() {
  const addErrorBorder = document.querySelector(
    "product-info variant-radios #Size",
  );
  if (addErrorBorder) addErrorBorder.style.borderBottom = "unset";
  const addBtn = document.querySelector(
    "product-form .product-form__buttons .product-form__submit span",
  );
  if (addBtn) {
    const addToCartText = document
      .querySelector(
        "product-form .product-form__buttons .product-form__submit",
      )
      .getAttribute("data-add-to-cart-text");
    addBtn.textContent = addToCartText;
    document
      .querySelector(
        "product-form .product-form__buttons .product-form__submit",
      )
      .removeAttribute("disabled");
  }
  const variantDropdown = document.querySelector(
    "variant-selects .select select",
  );
  if (variantDropdown) variantDropdown.style.border = "1px solid #bdbdbd";
}
